// https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/
import { dialLayerColor } from './colors';

export const dialLayerOptions = {
  type: 'fill-extrusion',
  paint: {
    'fill-extrusion-color': dialLayerColor,
    'fill-extrusion-opacity': 0.6,
  },
};
